export const catalogRoutes = [
    {
        path: '/catalog',
        meta: { requiresHousehold: true },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "catalog" */ '@/features/catalog/views/Catalog.vue'),
          }
        ]
    }
]